import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card7.scss';

class Card7 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>CGA é reformulada para acompanhar dinamismo do mercado - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card7-home page-gradient page-gradient--yellow bg-gray" ref="card7-home">
          <section className="iniciativas-area card7-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">CGA é reformulada para acompanhar dinamismo do mercado</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-12">
                              <p>
                                Preocupados em manter nossas certificações sempre alinhadas às atividades dos
                                profissionais que atuam no mercado, reformulamos a CGA (Certificação de Gestores ANBIMA)
                                para adequá-la aos avanços do setor de gestão de recursos de terceiros. O projeto de
                                atualização foi iniciado em 2019 e o novo modelo foi definido em 2020, com apresentação
                                ao mercado em outubro. O trabalho resultou no desmembramento da CGA em três
                                certificações:
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-2">
                              <img src={images.iniciativas.card7.img1} className="card7-icons" />
                            </div>
                            <div className="col-10">
                              <p>
                                <b>CFG (Certificação ANBIMA de Fundamentos em Gestão):</b> certificação para quem busca
                                diferenciação profissional para iniciar ou acelerar a carreira no mercado de gestão de
                                recursos. Não é obrigatória para uma função específica e nem habilita o profissional
                                para ser gestor, mas é pré-requisito para se certificar nas demais.
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-2">
                              <img src={images.iniciativas.card7.img2} className="card7-icons" />
                            </div>
                            <div className="col-10">
                              <p>
                                <b>CGA (Certificação de Gestores ANBIMA):</b> habilita os profissionais a fazerem
                                especificamente a gestão de fundos de renda fixa, de ações, multimercados e cambiais. O
                                nome foi mantido em razão da relevância que ele já tem no mercado.
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-2">
                              <img src={images.iniciativas.card7.img3} className="card7-icons" />
                            </div>
                            <div className="col-10">
                              <p>
                                <b>CGE (Certificação de Gestores ANBIMA para Fundos Estruturados):</b> habilita
                                profissionais a serem gestores de fundos imobiliários, fundos imobiliários, FIPs (Fundos
                                de Investimento em Participações) e FIDCs (Fundos de Investimento em Direitos
                                Creditórios), também conhecidos como fundos estruturados.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col-12 box">
                  <p>
                    Os primeiros exames neste formato devem acontecer no primeiro semestre de 2021. Os profissionais que
                    já possuíam a CGA antiga tiveram suas certificações convertidas automaticamente para o novo modelo,
                    passando a ser detentores das três novas certificações, uma vez que ela já os autorizava a atuar em
                    ambos os mercados da nova CGA e da CGE.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col-12 box">
                  <h1 className="title">Conheça nossas certificações</h1>
                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img4} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CPA-10 (Certificação Profissional ANBIMA – Série 10):</b> é destinada especialmente aos
                        gerentes de bancos e assessores de plataformas de investimento que atendem ao público de varejo
                        em geral.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img5} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CPA-20 (Certificação Profissional ANBIMA – Série 20):</b> voltada para os profissionais que
                        distribuem produtos para clientes dos segmentos varejo alta renda, private, corporate e
                        investidores institucionais. Ela permite também que o profissional desempenhe as atividades da
                        CPA-10.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img6} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CEA (Certificação de Especialista de Investimentos ANBIMA):</b> habilita o certificado a
                        recomendar produtos de investimento aos clientes em diversos segmentos. Abrange também as
                        atividades da CPA-10 e da CPA-20, permitindo ao profissional assessorar os gerentes de contas de
                        clientes pessoas físicas.
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img7} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CFG (Certificação ANBIMA de Fundamentos em Gestão):</b> lançada em 2020 para ser a porta de
                        entrada para o mercado de gestão, é indicada para quem quer acelerar sua carreira e busca um
                        diferencial para ocupar cargos nessa atividade. Não habilita o profissional a ser gestor, mas é
                        pré-requisito para a CGA e a CGE.
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img8} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CGA (Certificação de Gestores ANBIMA):</b> reformulada em 2020, a Certificação de Gestores
                        ANBIMA agora é uma habilitação específica para quem deseja atuar com gestão profissional de
                        recursos de terceiros em fundos de investimento de renda fixa, de ações, cambiais e
                        multimercados.
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <img src={images.iniciativas.card7.img9} className="card7-icons" />
                    </div>
                    <div className="col-10">
                      <p>
                        <b>CGE (Certificação de Gestores ANBIMA para Fundos Estruturados):</b> foi criada como um
                        desmembramento da antiga CGA, pois é voltada especificamente para a atuação em gestão
                        profissional de recursos de terceiros focada em produtos estruturados. O profissional
                        certificado poderá ser gestor de FIPs, FIDCs e fundos imobiliários.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card7 };
